import { useClientWebResolver } from '@cp/entities/clientWebRoutes';
import { useCallback } from 'react';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { coreLocationApi } from '@cp/entities/location';
import { Result } from '@youhelp-ru/core';
import { ClientSelection } from 'src/entities/client';

export type RequiredSelections = Required<Pick<ClientSelection, 'catalogType' | 'cityId' | 'careerId'>>;

/**
 * Собирает ссылку на каталог на основе выбора пользователя
 */
export const useBuildCatalogUrl = () => {
  const resolver = useClientWebResolver();
  const [getCityById] = coreLocationApi.endpoints.getCityById.useLazyQuery();
  return useCallback(
    async ({ cityId, careerId, catalogType }: RequiredSelections) => {
      const cityResult = await Result.fromAsync(() => getCityById({ id: cityId }).unwrap());
      return cityResult.map((city) =>
        resolver.resolve({
          page: ClientWebPage.Catalog,
          pageProps: { catalogType, careerId },
          cityAlias: city.alias,
        }),
      );
    },
    [resolver, getCityById],
  );
};
